<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">ผู้ใช้งาน</h6>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-12">
          <card header-classes="bg-transparent">
            <template v-slot:header>
              <div class="row align-items-center">
                <div class="col">
                  <h5 class="h3 mb-0">จัดการข้อมูลผู้ใช้งาน</h5>
                </div>
              </div>
            </template>
            <div class="row justify-content-end mt-3">
              <div class="form-group">
                <input
                  type="search"
                  v-model="searchQuery"
                  id="search"
                  class="form-control"
                  placeholder="ค้นหา"
                />
              </div>
            </div>
            <div class="row">
              <div
                class="col-md-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class="form-group">
                  <label for="selectshow" class="form-control-label"
                    >แสดง</label
                  >
                  <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                    style="width: 4.5rem"
                    id="selectshow"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  <label for="selectshow" class="form-control-label"
                    >รายการ</label
                  >
                </div>
                <base-pagination
                  class="pagination-no-border"
                  v-model="pagination.currentPage"
                  :per-page="pagination.perPage"
                  :total="total"
                >
                </base-pagination>
              </div>
            </div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-table
                v-loading="loading"
                :data="queriedData"
                header-row-class-name="thead-light"
              >
                <el-table-column
                  min-width="100px"
                  align="center"
                  label="รูปภาพ"
                >
                  <template v-slot:default="props">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      <div style="width: 50px; height: 50px">
                        <img
                          :src="props.row.picture_url"
                          @error="setImageFallback"
                          class="rounded-circle w-100 h-100"
                          style="object-fit: cover"
                        />
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="200px" align="center" label="ชื่อ">
                  <template v-slot:default="props">
                    <div class="font-weight-bold">
                      {{ props.row.display_name }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  min-width="200px"
                  align="center"
                  label="เข้าใช้งานล่าสุด"
                >
                  <template v-slot:default="props">
                    <div class="font-weight-bold">
                      {{ formatDateTimeISO(props.row.last_login_at) }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="150px" align="center" label="รหัส">
                  <template v-slot:default="props">
                    <div
                      class="font-weight-bold"
                      v-if="
                        props.row.access_key === '' ||
                        props.row.access_key === null
                      "
                    >
                      ไม่มีรหัส
                    </div>
                    <div
                      class="font-weight-bold d-flex align-items-center justify-content-center"
                      style="gap: 5px"
                      v-else
                    >
                      <span>
                        {{
                          showAccessKey[props.row.id]
                            ? props.row.access_key
                            : "******"
                        }}
                      </span>
                      <i
                        @click="setShowAccessKey(props.row.id)"
                        class="fa-regular fa-eye text-primary"
                        style="cursor: pointer"
                        v-if="showAccessKey[props.row.id]"
                      />
                      <i
                        @click="setShowAccessKey(props.row.id)"
                        class="fa-regular fa-eye-slash text-primary"
                        style="cursor: pointer"
                        v-else
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  min-width="200px"
                  align="center"
                  label="จัดการ"
                >
                  <template v-slot:default="props">
                    <base-button
                      size="sm"
                      type="warning"
                      @click="openEditAccessModal(props.$index)"
                      >แก้ไขรหัส</base-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <template v-slot:footer>
              <div
                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class="">
                  <p class="card-category">
                    แสดง {{ from + 1 }} ถึง {{ to }} จากทั้งหมด
                    {{ total }} รายการ
                  </p>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
  <modal v-model:show="modalEditAccessKey.show" size="sm">
    <card
      type="secondary"
      header-classes="bg-transparent border-0"
      class="border-0 mb-0"
    >
      <template v-slot:header>
        <div class="text-center">
          <h3 class="modal-title">แก้ไขรหัส</h3>
        </div>
      </template>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="edit_access_key" class="form-control-label">รหัส</label>
            <div
              class="d-flex justify-content-center align-items-center"
              style="cursor: pointer"
            >
              <input
                name="edit_access_key"
                id="edit_access_key"
                type="text"
                class="form-control input-group-alternative mr-2"
                v-model="modalEditAccessKey.accessKey"
              />
              <a
                class="text-primary font-weight-bold"
                @click="randomAccessKey()"
                >สุ่ม</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <button
          type="submit"
          class="btn btn-primary"
          @click="submitEditAccessModal"
        >
          ยืนยัน
        </button>
        <base-button type="danger" @click="closeEditAccessModal"
          >ปิด</base-button
        >
      </div>
    </card>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "../services/axios";
import { useToast } from "vue-toastification";
import "sweetalert2/dist/sweetalert2.css";
import {
  ElTable,
  ElTableColumn,
  ElSelect,
  ElOption,
  ElInput,
} from "element-plus";
import BasePagination from "@/components/BasePagination";
import modal from "../components/Modal.vue";
import { formatInTimeZone } from "date-fns-tz";
import defaultProductImage from "../assets/no-image.png";

const toast = useToast();

export default {
  name: "CustomerPage",
  components: {
    BasePagination,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
    [ElTable.name]: ElTable,
    [ElInput.name]: ElInput,
    [ElTableColumn.name]: ElTableColumn,
    modal,
  },
  data() {
    return {
      defaultProductImage,
      searchQuery: "",
      propsToSearch: ["display_name", "access_key"],
      tableData: [],
      searchedData: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      loading: false,
      showAccessKey: {},
      modalEditAccessKey: {
        show: false,
        accessKey: "",
        userId: "",
      },
    };
  },
  created() {
    this.fetchCustomersData();
  },
  methods: {
    randomAccessKey() {
      const key = Math.floor(100000 + Math.random() * 900000);
      this.modalEditAccessKey.accessKey = key;
    },
    formatDateTimeISO(isoString) {
      return formatInTimeZone(isoString, "UTC", "dd/MM/yyyy - HH:mm");
    },
    fetchCustomersData() {
      axios
        .get("/v2/backoffice/customers", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("AUTH"),
          },
        })
        .then((resp) => {
          if (resp?.data?.status) {
            this.tableData = resp?.data?.data || [];
          }
        })
        .catch((err) => {
          if (err?.response) {
            if (
              err?.response?.status !== 401 &&
              err?.response?.status !== 403
            ) {
              toast.error(
                err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "ไม่สามารถโหลดข้อมูลได้"
              );
            } else {
              this.$store.dispatch("logoutAuth");
              localStorage.removeItem("AUTH");
              this.$router.push("/login");
            }
          }
        });
    },
    setShowAccessKey(id) {
      if (this.showAccessKey[id]) {
        this.showAccessKey[id] = false;
      } else {
        this.showAccessKey[id] = true;
      }
    },
    submitEditAccessModal() {
      if (this.modalEditAccessKey.accessKey !== "" && String(this.modalEditAccessKey.accessKey).length !== 6) {
        toast.error("รหัสต้องมีทั้งหมด 6 ตัวเท่านั้น");
        return;
      }

      axios
        .post(
          "/v2/backoffice/update-access",
          {
            line_user_id: this.modalEditAccessKey.userId,
            access_key: String(this.modalEditAccessKey.accessKey),
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("AUTH"),
            },
          }
        )
        .then((resp) => {
          this.closeEditAccessModal();
          if (resp?.data?.status) {
            toast.success("บันทึกรหัสสำเร็จ");
            this.fetchCustomersData();
          } else {
            toast.error("ไม่สามารถบันทึกข้อมูลได้");
          }
        })
        .catch((err) => {
          console.log(err);

          this.closeEditAccessModal();
          if (err?.response) {
            if (
              err?.response?.status !== 401 &&
              err?.response?.status !== 403
            ) {
              toast.error(
                err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "ไม่สามารถบันทึกข้อมูลได้"
              );
            } else {
              this.$store.dispatch("logoutAuth");
              localStorage.removeItem("AUTH");
              this.$router.push("/login");
            }
          }
        });
    },
    setImageFallback(event) {
      const img = event.target;

      if (img && img.src !== this.defaultProductImage) {
        img.src = this.defaultProductImage;
        img.onerror = null;
      }
    },
    openEditAccessModal(key) {
      this.modalEditAccessKey.accessKey = this.queriedData[key].access_key;
      this.modalEditAccessKey.userId = this.queriedData[key].line_user_id;
      this.modalEditAccessKey.show = true;
    },
    closeEditAccessModal() {
      document.activeElement?.blur();
      this.modalEditAccessKey.show = false;
    },
  },
  computed: {
    ...mapGetters(["IsLoggedIn"]),
    pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      if (!this.searchQuery) {
        return this.pagedData;
      }
      let result = this.tableData.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });

      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
};
</script>

<style>
.el-table .el-table__header-wrapper thead th .cell {
  justify-content: center;
}
</style>
